import { useState } from 'react';
import { comments } from '@/mocks/home';

const SORTS = ['最热评论', '最新评论', '有反转的'];

export default function CommentSection() {
  const [sort, setSort] = useState('最热评论');
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState('');

  const toggleLike = (id: string) => setLiked((prev) => ({ ...prev, [id]: !prev[id] }));

  return (
    <section id="comment" className="w-full border-y border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="mb-6 flex flex-wrap items-center justify-between gap-3 border-b-2 border-foreground-950 pb-3">
              <div className="flex items-end gap-3">
                <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">吃瓜评论区</h3>
                <span className="mb-1 text-xs text-foreground-500">已有 18,642 位瓜友参与讨论</span>
              </div>
              <div className="flex items-center gap-1 rounded-full bg-background-50 p-1">
                {SORTS.map((s) => (
                  <button
                    key={s}
                    type="button"
                    onClick={() => setSort(s)}
                    className={`cursor-pointer whitespace-nowrap rounded-full px-3 py-1.5 text-xs transition-colors md:text-sm ${
                      sort === s ? 'bg-foreground-950 text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                    }`}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>

            <div className="mb-6 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="mb-3 flex items-center gap-2">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-200 text-sm font-bold text-secondary-900">
                  我
                </span>
                <span className="text-sm text-foreground-600">理性吃瓜，友善发言，请勿人身攻击</span>
              </div>
              <textarea
                value={draft}
                onChange={(e) => setDraft(e.target.value.slice(0, 500))}
                maxLength={500}
                rows={3}
                placeholder="说说你对这条爆料的看法…"
                className="w-full resize-none rounded-md border border-background-300 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-500 focus:border-primary-400"
              />
              <div className="mt-3 flex items-center justify-between">
                <span className="text-xs text-foreground-500">{draft.length} / 500</span>
                <button
                  type="button"
                  className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  发表评论
                </button>
              </div>
            </div>

            <ul className="space-y-4">
              {comments.map((c) => {
                const isLiked = !!liked[c.id];
                return (
                  <li key={c.id} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                    <div className="flex items-start gap-3">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-100 font-heading text-sm font-bold text-primary-700">
                        {c.user.slice(0, 1)}
                      </span>
                      <div className="min-w-0 flex-1">
                        <div className="flex flex-wrap items-center gap-2">
                          <span className="text-sm font-bold text-foreground-900">{c.user}</span>
                          <span className="text-xs text-foreground-500">{c.time}</span>
                          {c.likes > 800 && (
                            <span className="rounded-md bg-accent-100 px-2 py-0.5 text-xs text-accent-900">神评</span>
                          )}
                        </div>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-700">{c.content}</p>
                        <div className="mt-3 flex flex-wrap items-center gap-5 text-xs text-foreground-500">
                          <button
                            type="button"
                            onClick={() => toggleLike(c.id)}
                            className={`flex cursor-pointer items-center gap-1.5 transition-colors ${
                              isLiked ? 'text-primary-600' : 'hover:text-primary-600'
                            }`}
                          >
                            <i className={isLiked ? 'ri-thumb-up-fill' : 'ri-thumb-up-line'} />
                            {c.likes + (isLiked ? 1 : 0)}
                          </button>
                          <button type="button" className="flex cursor-pointer items-center gap-1.5 transition-colors hover:text-primary-600">
                            <i className="ri-chat-3-line" />
                            {c.replies} 条回复
                          </button>
                          <button type="button" className="flex cursor-pointer items-center gap-1.5 transition-colors hover:text-primary-600">
                            <i className="ri-share-forward-line" />
                            分享
                          </button>
                        </div>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>

          <aside className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5">
              <h4 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-emotion-happy-line text-primary-600" />
                吃瓜氛围值
              </h4>
              <div className="space-y-4">
                {[
                  { label: '震惊指数', value: 92 },
                  { label: '质疑声量', value: 74 },
                  { label: '围观热情', value: 88 },
                ].map((bar) => (
                  <div key={bar.label}>
                    <div className="mb-1.5 flex items-center justify-between text-xs text-foreground-600">
                      <span>{bar.label}</span>
                      <span className="font-medium text-primary-600">{bar.value}%</span>
                    </div>
                    <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                      <div className="h-full rounded-full bg-primary-500" style={{ width: `${bar.value}%` }} />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-secondary-50 p-5">
              <h4 className="mb-3 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-shield-line text-secondary-600" />
                社区公约
              </h4>
              <ul className="space-y-2.5 text-sm leading-relaxed text-foreground-700">
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
                  只讨论已被公开的信息，不扩散隐私
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
                  标注来源，拒绝无出处的截图
                </li>
                <li className="flex gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" />
                  理性表达，禁止人身攻击与造谣
                </li>
              </ul>
            </div>

            <div className="rounded-lg border border-primary-200 bg-primary-50 p-5">
              <h4 className="mb-2 font-heading text-lg font-bold text-primary-800">爆料有奖</h4>
              <p className="text-sm leading-relaxed text-foreground-700">提供有效线索并被核实采用，将获得爆料打赏与署名展示。</p>
              <a
                href="#today"
                className="mt-4 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-add-circle-line" />
                提交线索
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}